import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './../store';
import { recursionCopy } from '@/views/customer/roleManage/utils';
Vue.use(VueRouter);
import Layout from '@/layouts';
import mainLayout from '@/layouts/mainLayout';
// import echartRouter from './modules/echarts';
// import componentsRouter from './modules/components';

//基础路由
export const baseRoute = [{
  name: 'login',
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
}, {
  name: 'account',
  path: '/account',
  component: () => import('@/views/login/account'),
  hidden: true
}, {
  path: '/403',
  component: () => import('@/views/error/403'),
  hidden: true
}, {
  path: '/404',
  component: () => import('@/views/error/404'),
  hidden: true
}, {
  path: '/500',
  component: () => import('@/views/error/500'),
  hidden: true
}, {
  name: 'previewPage',
  path: '/system/settings/previewPage/:id/:language/:type',
  component: () => import('@/views/system/settings/previewPage'),
  hidden: true
}, {
  path: '',
  component: Layout,
  hidden: true,
  children: [{
    name: 'system',
    component: mainLayout,
    path: '/system/',
    hidden: true,
    meta: {
      title: '系统管理'
    },
    children: [{
      name: 'customerHomeInfo',
      path: '/system/customerManage/:id/:type',
      component: () => import('@/views/system/customerManage/customerInfo'),
      meta: {
        title: '客户信息'
      },
      hidden: true
    }, {
      name: 'roleCofing',
      path: '/system/roleManage/:id',
      component: () => import('@/views/system/roleManage/roleCofing'),
      meta: {
        title: '角色配置'
      },
      hidden: true
    }, {
      name: 'labelProperty',
      path: '/system/labelManage/:tagsName',
      component: () => import('@/views/system/labelManage/labelPropertyManage'),
      meta: {
        title: '属性管理'
      },
      hidden: true
    }, {
      name: 'personalCenter',
      path: '/system/accountManage/personalCenter/:id',
      component: () => import('@/views/system/accountManage/personalCenter'),
      meta: {
        title: '个人中心'
      },
      hidden: true
    }, {
      name: 'editInfo',
      path: '/system/editInfo/:id',
      component: () => import('@/views/system/editInfo/index.vue'),
      meta: {
        title: '编辑个人信息'
      },
      hidden: true
    }, {
      name: 'addField',
      path: '/system/fieldLibrary/add/addField/:id',
      component: () => import('@/views/system/fieldLibrary/addField.vue'),
      meta: {
        title: '新增字段'
      },
      hidden: true
    }]
  }, {
    name: 'administrators',
    component: mainLayout,
    path: '/administrators/',
    hidden: true,
    meta: {
      title: '管理员管理'
    },
    children: [{
      name: 'administratorsRoleAuthority',
      path: '/administrators/roleManage/:id',
      component: () => import('@/views/administrators/roleManage/roleCofing'),
      meta: {
        title: '角色配置'
      },
      hidden: true
    }, {
      name: 'administratorsAccountInfo',
      path: '/administrators/accountManage/:id/:customerId',
      component: () => import('@/views/administrators/accountManage/accountInfo'),
      meta: {
        title: '账号操作'
      },
      hidden: true
    }]
  }, {
    name: 'message',
    component: mainLayout,
    path: '/message/',
    hidden: true,
    meta: {
      title: '消息中心'
    },
    children: [{
      name: 'messageList',
      path: '/message/systemManage/messageList/',
      component: () => import('@/views/message/systemManage/messageList'),
      meta: {
        title: '系统消息'
      },
      hidden: true
    }]
  }, {
    name: 'customer',
    component: mainLayout,
    path: '/customer/',
    hidden: true,
    meta: {
      title: '客户管理'
    },
    children: [{
      name: 'accountInfo',
      path: '/customer/accountManage/:id/:customerId',
      component: () => import('@/views/customer/accountManage/accountInfo'),
      meta: {
        title: '账号操作'
      },
      hidden: true
    }, {
      name: 'roleHomeCofing',
      path: '/customer/roleManage/:id',
      component: () => import('@/views/customer/roleManage/roleCofing'),
      meta: {
        title: '角色配置'
      },
      hidden: true
    }]
  }, {
    name: 'insurance',
    component: mainLayout,
    path: '/insurance/',
    hidden: true,
    meta: {
      title: '保险产品'
    },
    children: [{
      name: 'additional',
      path: '/insurance/insuranceManage/additional/:id',
      component: () => import('@/views/insurance/insuranceManage/additional'),
      meta: {
        title: '附加险'
      },
      hidden: true
    }, {
      name: 'addMain',
      path: '/insurance/insuranceManage/addMain/:id',
      component: () => import('@/views/insurance/insuranceManage/addMain'),
      meta: {
        title: '主险'
      },
      hidden: true
    }, {
      name: 'organizationalInfo',
      path: '/insurance/organizationalManage/organizationalInfo/:unit/:agency/:id/:level',
      component: () => import('@/views/insurance/organizationalManage/organizationalInfo'),
      meta: {
        title: '分支机构'
      },
      hidden: true
    }, {
      name: 'labelIndex',
      path: '/insurance/categoryLabelManage/labelIndex/:id',
      component: () => import('@/views/insurance/categoryLabelManage/labelIndex'),
      meta: {
        title: '标签'
      },
      hidden: true
    }, {
      name: 'releaseInfo',
      path: '/insurance/releaseManage/releaseInfo/:id/:insuranceId',
      component: () => import('@/views/insurance/releaseManage/releaseInfo'),
      meta: {
        title: '发布信息'
      },
      hidden: true
    }, {
      name: 'releasePlanHomeInfo',
      path: '/insurance/releaseManage/releasePlanHomeInfo/:id',
      component: () => import('@/views/insurance/releaseManage/releasePlanInfo'),
      meta: {
        title: '方案详情'
      },
      hidden: true
    }, {
      name: 'insuranceInfo',
      path: '/product/productManage/insuranceInfo/:id/:type',
      component: () => import('@/views/product/productManage/insuranceInfo'),
      meta: {
        title: '产品详情'
      },
      hidden: true
    }, {
      name: 'customerLabelIndex',
      path: '/product/categoryLabelManage/labelIndex/:id',
      component: () => import('@/views/product/categoryLabelManage/labelIndex'),
      meta: {
        title: '标签'
      },
      hidden: true
    }]
  }, {
    name: 'order',
    component: mainLayout,
    path: '/order/',
    hidden: true,
    meta: {
      title: '订单管理'
    },
    children: [{
      name: 'homeOrder',
      path: '/order/homeManage/:id',
      component: () => import('@/views/order/homeManage/orderInfo'),
      meta: {
        title: '订单详情'
      },
      hidden: true
    }, {
      name: 'customerOrder',
      path: '/order/customerManage/:id',
      component: () => import('@/views/order/customerManage/orderInfo'),
      meta: {
        title: '订单详情'
      },
      hidden: true
    }]
  }, {
    name: 'policy',
    component: mainLayout,
    path: '/policy/',
    hidden: true,
    meta: {
      title: '保单管理'
    },
    children: [{
      name: 'homePersonnelDetail',
      path: '/policy/homeManage/personnel/personnelDetail/:id',
      component: () => import('@/views/policy/homeManage/personnelDetail/index'),
      meta: {
        title: '人员明细'
      },
      hidden: true
    }, {
      name: 'homeDetailInfo',
      path: '/policy/homeManage/detailInfo/:id/:detailId',
      component: () => import('@/views/policy/homeManage/detailInfo'),
      meta: {
        title: '人员详情'
      },
      hidden: true
    }, {
      name: 'customerDetailInfo',
      path: '/policy/customerManage/detailInfo/:id/:detailId',
      component: () => import('@/views/policy/customerManage/detailInfo'),
      meta: {
        title: '人员详情'
      },
      hidden: true
    }, {
      name: 'customerPersonnelDetail',
      path: '/policy/customerManage/personnel/personnelDetail/:policyType/:id',
      component: () => import('@/views/policy/customerManage/personnelDetail/index'),
      meta: {
        title: '人员明细'
      },
      hidden: true
    }, {
      name: 'homePolicy',
      path: '/policy/homeManage/policyInfo/:id',
      component: () => import('@/views/policy/homeManage/policyInfo'),
      meta: {
        title: '保单详情'
      },
      hidden: true
    }, {
      name: 'customerPolicy',
      path: '/policy/customerManage/policyInfo/:id',
      component: () => import('@/views/policy/customerManage/policyInfo'),
      meta: {
        title: '保单详情'
      },
      hidden: true
    }, {
      name: 'customerAddPolicyInfo',
      path: '/policy/customerManage/add/addPolicyInfo',
      component: () => import('@/views/policy/customerManage/addPolicyInfo'),
      meta: {
        title: '手动录入'
      },
      hidden: true
    }, {
      name: 'editPolicyInfo',
      path: '/policy/homeManage/edit/editPolicyInfo/:id',
      component: () => import('@/views/policy/homeManage/editPolicyInfo'),
      meta: {
        title: '编辑保单'
      },
      hidden: true
    }, {
      name: 'correctionApplication',
      path: '/policy/customerManage/correctionApplication/:id/:type',
      component: () => import('@/views/policy/customerManage/correctionApplication/index'),
      meta: {
        title: '批改申请'
      },
      hidden: true
    }, {
      name: 'customerCorrectionRecord',
      path: '/policy/customerManage/correctionRecord/:id',
      component: () => import('@/views/policy/customerManage/correctionRecord'),
      meta: {
        title: '批改记录'
      },
      hidden: true
    }, {
      name: 'homeCorrectionRecord',
      path: '/policy/homeManage/correctionRecord/:id',
      component: () => import('@/views/policy/homeManage/correctionRecord/index'),
      meta: {
        title: '批改记录'
      },
      hidden: true
    }]
  }, {
    name: 'invoiceManage',
    component: mainLayout,
    path: '/invoiceManage/',
    hidden: true,
    meta: {
      title: '发票管理'
    },
    children: [{
      name: 'homeInvoiceWrite',
      path: '/invoiceManage/homeManage/invoiceList/invoiceWrite/:num',
      component: () => import('@/views/invoiceManage/homeManage/invoiceList/invoiceWrite'),
      meta: {
        title: '发票填写'
      },
      hidden: true
    }, {
      name: 'customerInvoiceWrite',
      path: '/invoiceManage/customerManage/invoiceList/invoiceWrite/:num',
      component: () => import('@/views/invoiceManage/customerManage/invoiceList/invoiceWrite'),
      meta: {
        title: '发票填写'
      },
      hidden: true
    }, {
      name: 'homeInvoiceDetail',
      path: '/invoiceManage/homeManage/invoiceRecord/invoiceDetail/:id',
      component: () => import('@/views/invoiceManage/homeManage/invoiceRecord/invoiceDetail'),
      meta: {
        title: '发票详情'
      },
      hidden: true
    }, {
      name: 'customerInvoiceDetail',
      path: '/invoiceManage/customerManage/invoiceRecord/invoiceDetail/:id',
      component: () => import('@/views/invoiceManage/customerManage/invoiceRecord/invoiceDetail'),
      meta: {
        title: '发票详情'
      },
      hidden: true
    }]
  }, {
    name: 'examine',
    component: mainLayout,
    path: '/examine/',
    hidden: true,
    meta: {
      title: '审核中心'
    },
    children: [{
      name: 'homeAuditSet',
      path: '/examine/auditUsedManage/:id',
      component: () => import('@/views/examine/auditUsedManage/auditSet'),
      meta: {
        title: '审核流设置'
      },
      hidden: true
    }, {
      name: 'customerPolicy',
      path: '/policy/customerManage/policyInfo/:id',
      component: () => import('@/views/policy/customerManage/policyInfo'),
      meta: {
        title: '保单详情'
      },
      hidden: true
    }, {
      name: 'homeLine',
      path: '/examine/lineManage/:id/:type',
      component: () => import('@/views/examine/lineManage/lineInfo'),
      meta: {
        title: '产品上下线审核详情'
      },
      hidden: true
    }, {
      name: 'homeModify',
      path: '/examine/modifyManage/:id/:type',
      component: () => import('@/views/examine/modifyManage/modifyInfo'),
      meta: {
        title: '产品修改审核详情'
      },
      hidden: true
    }, {
      name: 'customerLine',
      path: '/examine/customerLineManage/:id/:type',
      component: () => import('@/views/examine/customerLineManage/lineInfo'),
      meta: {
        title: '产品上下线审核详情'
      },
      hidden: true
    }, {
      name: 'customerModify',
      path: '/examine/customerModifyManage/:id/:type',
      component: () => import('@/views/examine/customerModifyManage/modifyInfo'),
      meta: {
        title: '产品修改审核详情'
      },
      hidden: true
    }, {
      name: 'customerClaim',
      path: '/examine/claimRecordManage/:id/:type/:auditFlowTypeId/:policyId',
      component: () => import('@/views/examine/claimRecordManage/claimInfo'),
      meta: {
        title: '理赔详情'
      },
      hidden: true
    }, {
      name: 'customerUsedClaim',
      path: '/examine/claimRecordUsedManage/:id/:type/:nodeid',
      component: () => import('@/views/examine/claimRecordUsedManage/claimInfo'),
      meta: {
        title: '理赔详情'
      },
      hidden: true
    }, {
      name: 'homeAuditInfo',
      path: '/examine/auditManage/auditInfo/:id',
      component: () => import('@/views/examine/auditManage/auditInfo'),
      meta: {
        title: '审核流设置'
      },
      hidden: true
    }, {
      name: 'questionnaireReview',
      path: '/examine/questionnaireExamine/questionnaireReview/:id/:type/:auditFlowTypeId',
      component: () => import('@/views/examine/questionnaireExamine/questionnaireReview'),
      meta: {
        title: '问卷审核'
      },
      hidden: true
    }]
  }, {
    name: 'organization',
    component: mainLayout,
    path: '/organization/',
    hidden: true,
    meta: {
      title: '组织管理'
    },
    children: [{
      name: 'framework',
      path: '/organization/companyManage/:id/:customerId',
      component: () => import('@/views/organization/companyManage/framework'),
      meta: {
        title: '架构图'
      },
      hidden: true
    }, {
      name: 'companyInfoHome',
      path: '/organization/companyInfo/:id/:customerId',
      component: () => import('@/views/organization/companyManage/companyInfo'),
      meta: {
        title: '架构详情'
      },
      hidden: true
    }, {
      name: 'staffInfoHome',
      path: '/organization/staffManage/:id/:type/:structure/:customerId',
      component: () => import('@/views/organization/staffManage/staffInfo'),
      meta: {
        title: '员工信息'
      },
      hidden: true
    }, {
      name: 'transferHome',
      path: '/organization/staffManageTransfer/:id',
      component: () => import('@/views/organization/staffManage/transfer'),
      meta: {
        title: '员工迁移'
      },
      hidden: true
    }, {
      name: 'quitHome',
      path: '/organization/staffManageQuit/:id',
      component: () => import('@/views/organization/staffManage/quit'),
      meta: {
        title: '员工离职'
      },
      hidden: true
    }, {
      name: 'frameworkCustomer',
      path: '/organization/companyCustomerManage/:id',
      component: () => import('@/views/organization/companyCustomerManage/framework'),
      meta: {
        title: '架构图'
      },
      hidden: true
    }, {
      name: 'companyInfoCustomer',
      path: '/organization/companyInfoCustomer/:id',
      component: () => import('@/views/organization/companyCustomerManage/companyInfo'),
      meta: {
        title: '架构详情'
      },
      hidden: true
    }, {
      name: 'staffInfoCustomer',
      path: '/organization/staffCustomerManage/:id/:type/:structure',
      component: () => import('@/views/organization/staffCustomerManage/staffInfo'),
      meta: {
        title: '员工信息'
      },
      hidden: true
    }, {
      name: 'transferCustomer',
      path: '/organization/staffCustomerManageTransfer/:id',
      component: () => import('@/views/organization/staffCustomerManage/transfer'),
      meta: {
        title: '员工迁移'
      },
      hidden: true
    }, {
      name: 'quitCustomer',
      path: '/organization/staffCustomerManageQuit/:id',
      component: () => import('@/views/organization/staffCustomerManage/quit'),
      meta: {
        title: '员工离职'
      },
      hidden: true
    }]
  }, {
    name: 'contract',
    component: mainLayout,
    path: '/contract/',
    hidden: true,
    meta: {
      title: '合同管理'
    },
    children: [{
      name: 'contractHome',
      path: '/contract/contractManage/:id/:type',
      component: () => import('@/views/contract/contractManage/contractInfo'),
      meta: {
        title: '合同信息'
      },
      hidden: true
    }, {
      name: 'contractCustomer',
      path: '/contract/customerManage/:id/:type',
      component: () => import('@/views/contract/customerManage/contractInfo'),
      meta: {
        title: '合同信息'
      },
      hidden: true
    }]
  }, {
    name: 'supervise',
    component: mainLayout,
    path: '/supervise/',
    hidden: true,
    meta: {
      title: '监管报备'
    },
    children: [{
      name: 'personalBusinessHome',
      path: '/supervise/personalBusinessManage/:id',
      component: () => import('@/views/supervise/personalBusinessManage/personalBusinessInfo'),
      meta: {
        title: '查看业务报表'
      },
      hidden: true
    }, {
      name: 'yieldBusinessHome',
      path: '/supervise/yieldBusinessManage/:id',
      component: () => import('@/views/supervise/yieldBusinessManage/yieldBusinessInfo'),
      meta: {
        title: '查看业务报表'
      },
      hidden: true
    }]
  }, {
    name: 'claim',
    component: mainLayout,
    path: '/claim/',
    hidden: true,
    meta: {
      title: '理赔管理'
    },
    children: [{
      name: 'claimProductInfoHome',
      path: '/claim/productManage/:id',
      component: () => import('@/views/claim/productManage/productInfo'),
      meta: {
        title: '理赔配置'
      },
      hidden: true
    }, {
      name: 'customerRecordManageInfo',
      path: '/claim/customerRecordManage/customer/:id',
      component: () => import('@/views/claim/customerRecordManage/info'),
      meta: {
        title: '理赔申请详情'
      },
      hidden: true
    }, {
      name: 'customerRecordManageProgress',
      path: '/claim/customerRecordManage/progress/:id',
      component: () => import('@/views/claim/customerRecordManage/progress'),
      meta: {
        title: '理赔进度'
      },
      hidden: true
    }, {
      name: 'recordUseHome',
      path: '/claim/recordUsedManage/:id',
      component: () => import('@/views/claim/recordUsedManage/claimInfo'),
      meta: {
        title: '理赔详情'
      },
      hidden: true
    }, {
      name: 'recordHome',
      path: '/claim/recordManage/:id/:auditFlowTypeId/:policyId',
      component: () => import('@/views/claim/recordManage/claimInfo'),
      meta: {
        title: '理赔详情'
      },
      hidden: true
    },
    // {
    //   name: 'customerAddClaim',
    //   path: '/policy/customerManage/add/addClaim/:id/:type',
    //   component: () => import('@/views/policy/customerManage/addClaim'),
    //   meta: {title: '发起理赔申请'},
    //   hidden: true
    // }
    {
      name: 'customerAddClaim',
      path: '/policy/customerManage/add/addClaim/:id/:auditFlowId/:type',
      component: () => import('@/views/claim/customerReportManage/addClaim'),
      meta: {
        title: '理赔报案'
      },
      hidden: true
    }]
  }, {
    name: 'salesman',
    component: mainLayout,
    path: '/salesman/',
    hidden: true,
    meta: {
      title: '业务员管理'
    },
    children: [{
      name: 'salesmanStaffManageHome',
      path: '/salesman/staffManage/:id/:type/:structure/:customerId',
      component: () => import('@/views/salesman/staffManage/staffInfo'),
      meta: {
        title: '员工信息'
      },
      hidden: true
    }, {
      name: 'salesmanUpgradeHome',
      path: '/salesman/staffManage/upgrade/:id',
      component: () => import('@/views/salesman/staffManage/upgrade'),
      meta: {
        title: '业务员升级'
      },
      hidden: true
    }, {
      name: 'salesmanQuitHome',
      path: '/salesman/staffManage/quit/:id',
      component: () => import('@/views/salesman/staffManage/quit'),
      meta: {
        title: '业务员离职'
      },
      hidden: true
    }, {
      name: 'salesmanTransferHome',
      path: '/salesman/staffManage/transfer/:id',
      component: () => import('@/views/salesman/staffManage/transfer'),
      meta: {
        title: '业务员迁移'
      },
      hidden: true
    }, {
      name: 'salesmanRankHome',
      path: '/salesman/rankManage/:id',
      component: () => import('@/views/salesman/rankManage/rankInfo'),
      meta: {
        title: '职级维护'
      },
      hidden: true
    }]
  }, {
    name: 'task',
    path: '/task',
    component: () => import('@/views/reportForm/task'),
    meta: {
      title: '任务列表'
    },
    hidden: true
  }, {
    name: 'messageCenter',
    path: '/messageCenter/:tabKey',
    component: () => import('@/views/reportForm/messageCenter/index.vue'),
    meta: {
      title: '消息中心'
    },
    hidden: true
  }, {
    name: 'template',
    component: mainLayout,
    path: '/template/',
    hidden: true,
    meta: {
      title: '模板管理'
    },
    children: [{
      name: 'templateControlManage',
      path: '/template/controlManage/controlGroup/:id',
      component: () => import('@/views/template/controlManage/groupFrom/controlGroup'),
      meta: {
        title: '单元组件'
      },
      hidden: true
    }, {
      name: 'templateConfiguration',
      path: '/template/frontPageManage/configureManage/:type/:id',
      component: () => import('@/views/template/frontPageManage/configureManage/templateConfiguration'),
      meta: {
        title: '模板配置'
      },
      hidden: true
    }, {
      name: 'addFunction',
      path: '/template/componentFunction/:type/:id',
      component: () => import('@/views/template/componentFunction/addFunction.vue'),
      meta: {
        title: '新增函数'
      },
      hidden: true
    }, {
      name: 'containerTemplateTableDesign',
      path: '/template/containerTemplateComponent/tableDesign/:type/:columnNum/:id',
      component: () => import('@/views/template/containerTemplateComponent/tableDesign.vue'),
      meta: {
        title: '表格设计区'
      },
      hidden: true
    }, {
      name: 'quickConfiguration',
      path: '/template/containerTemplateComponent/quickConfiguration/:type',
      component: () => import('@/views/template/containerTemplateComponent/quickConfiguration.vue'),
      meta: {
        title: '快捷配置'
      },
      hidden: true
    }]
  }, {
    name: 'insure',
    component: mainLayout,
    path: '/insure/',
    hidden: true,
    meta: {
      title: '投保管理'
    },
    children: [{
      name: 'InsureDetail',
      path: '/insure/components/insureDetail/:customerId/:batchPolicyId',
      component: () => import('@/views/insure/components/insureDetail'),
      meta: {
        title: '投保详情'
      },
      hidden: true
    }, {
      name: 'InsureAdd',
      path: '/insure/customInsureManage/addInsure',
      component: () => import('@/views/insure/customInsureManage/addInsure'),
      meta: {
        title: '新增投保'
      },
      hidden: true
    }]
  }, {
    name: 'payment',
    component: mainLayout,
    path: '/payment/',
    hidden: true,
    meta: {
      title: '支付管理'
    },
    children: [{
      name: 'payDetail',
      path: '/payment/customListManage/payDetailList/:customerId/:payInfoId',
      component: () => import('@/views/payment/customListManage/payDetailList'),
      meta: {
        title: '支付明细'
      },
      hidden: true
    }, {
      name: 'toPay',
      path: '/payment/customListManage/toPay/:customerId/:batchPolicyId/:position',
      component: () => import('@/views/payment/customListManage/toPay'),
      meta: {
        title: '支付'
      },
      hidden: true
    }]
  }, {
    name: '',
    component: mainLayout,
    path: '/questionnaire',
    hidden: true,
    meta: {
      title: '问卷管理'
    },
    children: [{
      name: 'questionnaireRecord',
      path: '/questionnaire/homeManage/questionnaireRecord',
      component: () => import('@/views/questionnaire/homeManage/questionnaireRecord/index.vue'),
      meta: {
        title: '问卷记录'
      },
      hidden: true
    }, {
      name: 'questionnaireCheck',
      path: '/questionnaire/homeManage/questionnaireRecord/questionnaireCheck/:id/:type/:auditFlowTypeId/:flowMark',
      component: () => import('@/views/questionnaire/homeManage/questionnaireRecord/questionnaireCheck'),
      meta: {
        title: '问卷查看'
      },
      hidden: true
    }, {
      name: 'questionnaireList',
      path: '/questionnaire/customerManage/questionnaireList',
      component: () => import('@/views/questionnaire/customerManage/questionnaireList/index.vue'),
      meta: {
        title: '问卷列表'
      },
      hidden: true
    }, {
      name: 'questionnaireCustomerRecord',
      path: '/questionnaire/customerManage/questionnaireRecord',
      component: () => import('@/views/questionnaire/customerManage/questionnaireRecord/index.vue'),
      meta: {
        title: '问卷记录'
      },
      hidden: true
    }, {
      name: 'questionModer',
      path: '/questionnaire/customerManage/questionnaireList/questionModer/ModerIndex/:id',
      component: () => import('@/views/questionnaire/customerManage/questionnaireList/questionModer/ModerIndex.vue'),
      meta: {
        title: '问卷填写'
      },
      hidden: true
    }]
  }, {
    name: 'notify',
    component: mainLayout,
    path: '/notify/',
    hidden: true,
    meta: {
      title: '消息管理'
    },
    children: [{
      name: 'editScene',
      path: '/notify/systemScene/editScene/:id',
      component: () => import('@/views/notify/systemScene/sceneEdit.vue'),
      meta: {
        title: '场景编辑'
      },
      hidden: true
    }, {
      name: 'newMessageSetting',
      path: '/notify/customerMessageManagement/messageSetting/:copyId/:id',
      component: () => import('@/views/notify/customerMessageManagement/newMessageSetting.vue'),
      meta: {
        title: '场景设置'
      },
      hidden: true
    }, {
      name: 'newSystemMessage',
      path: '/notify/messageLog/newSystemMessage',
      component: () => import('@/views/notify/messageLog/newSystemMessage.vue'),
      meta: {
        title: '新增系统消息'
      },
      hidden: true
    }, {
      name: 'systemMessageDetail',
      path: '/notify/messageLog/systemMessageDetail/:id',
      component: () => import('@/views/notify/messageLog/systemMessageDetail.vue'),
      meta: {
        title: '查看系统消息'
      },
      hidden: true
    }]
  }, {
    name: 'groupOrderManage',
    component: mainLayout,
    path: '/groupOrderManage/',
    hidden: true,
    meta: {
      title: '团单管理'
    },
    children: [{
      name: 'groupOrderInsuranceDetail',
      path: '/groupOrderManage/batchInsurance/insuranceDetail/:id',
      component: () => import('@/views/groupOrderManage/batchInsurance/insuranceDetail.vue'),
      meta: {
        title: '保险详情'
      },
      hidden: true
    },
    // {
    //   name: 'groupOrderExamine',
    //   path: '/groupOrderManage/groupOrderExamine/index',
    //   component: () => import('@/views/groupOrderManage/groupOrderExamine/index'),
    //   meta: {title: '团单审核'},
    //   hidden: true
    // },
    {
      name: 'groupOrderExamineDetail',
      path: '/groupOrderManage/groupOrderExamine/:id/:type/:auditFlowTypeId/:policyId',
      component: () => import('@/views/groupOrderManage/groupOrderExamine/claimInfo'),
      meta: {
        title: '理赔详情'
      },
      hidden: true
    }]
  }]
}];
const ARR = [{
  name: 'supervise',
  component: mainLayout,
  path: '/supervise',
  redirect: '/supervise/organizationManage',
  meta: {
    title: '监管报备',
    icon: 'jianguan'
  },
  children: [{
    name: 'organizationManage',
    path: '/supervise/organizationManage',
    component: () => import('@/views/supervise/organizationManage/index'),
    meta: {
      title: '机构基本情况报表'
    }
  }, {
    name: 'personalDetailedListManage',
    path: '/supervise/personalDetailedListManage',
    component: () => import('@/views/supervise/personalDetailedListManage/index'),
    meta: {
      title: '人身险业务结算清单'
    }
  }, {
    name: 'personalBusinessManage',
    path: '/supervise/personalBusinessManage',
    component: () => import('@/views/supervise/personalBusinessManage/index'),
    meta: {
      title: '人身险业务报表'
    }
  }, {
    name: 'yieldDetailedListManage',
    path: '/supervise/yieldDetailedListManage',
    component: () => import('@/views/supervise/yieldDetailedListManage/index'),
    meta: {
      title: '产险业务结算清单'
    }
  }, {
    name: 'yieldBusinessManage',
    path: '/supervise/yieldBusinessManage',
    component: () => import('@/views/supervise/yieldBusinessManage/index'),
    meta: {
      title: '产险业务报表'
    }
  }, {
    name: 'brokerBusinessManage',
    path: '/supervise/brokerBusinessManage',
    component: () => import('@/views/supervise/brokerBusinessManage/index'),
    meta: {
      title: '经纪咨询业务'
    }
  }, {
    name: 'brokerInsuranceManage',
    path: '/supervise/brokerInsuranceManage',
    component: () => import('@/views/supervise/brokerInsuranceManage/index'),
    meta: {
      title: '经纪再保险'
    }
  }]
}, {
  name: 'salesman',
  component: mainLayout,
  path: '/salesman',
  redirect: '/salesman/staffManage',
  meta: {
    title: '业务员管理',
    icon: 'yewuyuan'
  },
  children: [{
    name: 'staffManage',
    path: '/salesman/staffManage',
    component: () => import('@/views/salesman/staffManage/index'),
    meta: {
      title: '业务员管理'
    }
  }, {
    name: 'rankManage',
    path: '/salesman/rankManage',
    component: () => import('@/views/salesman/rankManage/index'),
    meta: {
      title: '职级维护'
    }
  }
  // {
  //   name: 'customerRecordManage',
  //   path: '/claim/customerRecordManage',
  //   component: () => import('@/views/claim/customerRecordManage/index'),
  //   meta: {title: '理赔记录(客户)'}
  // },
  // {
  //   name: 'recordManage',
  //   path: '/claim/recordManage',
  //   component: () => import('@/views/claim/recordManage/index'),
  //   meta: {title: '理赔记录'}
  // }
  // {
  //   name: 'demageManage',
  //   path: '/claim/demageManage',
  //   component: () => import('@/views/claim/demageManage/index'),
  //   meta: {title: '索赔清单'}
  // },
  // {
  //   name: 'productManage',
  //   path: '/claim/productManage',
  //   component: () => import('@/views/claim/productManage/index'),
  //   meta: {title: '理赔产品'}
  // },
  // {
  //   name: 'staffManage',
  //   path: '/salesman/staffManage',
  //   component: () => import('@/views/salesman/staffManage/index'),
  //   meta: {title: '业务员管理'}
  // }
  ]
}
// {
//   name: 'payment',
//   component: mainLayout,
//   path: '/payment/',
//   meta: {title: '支付管理', icon: 'jianguan'},
//   children: [
//     {
//       name: 'refundManage',
//       path: '/payment/refundManage/index',
//       component: () => import('@/views/payment/refundManage/index'),
//       meta: {title: '退款列表'}
//     },
//     {
//       name: 'listManage',
//       path: '/payment/listManage/index',
//       component: () => import('@/views/payment/listManage/index'),
//       meta: {title: '支付列表'}
//     }
//   ]
// }
];
export const asyncRoutes = [{
  path: '/',
  component: Layout,
  redirect: '/index',
  name: 'index',
  hidden: true,
  children: []
}, {
  path: '*',
  redirect: '/index',
  hidden: true
}];
export function addedRouter(async) {
  const {
    menuList
  } = store.state.user.accountInfo;
  asyncRoutes[0].children = [];
  if (process.env.NODE_ENV != 'production') {
    asyncRoutes[0].children = recursionCopy(ARR);
  }
  const result = menuList.find(ele => ele.name === '首页');
  if (!result) {
    asyncRoutes[0].children.unshift({
      name: 'index',
      path: '/index',
      component: () => import('@/views/index/imgIndex'),
      meta: {
        title: '首页',
        icon: 'home'
      }
    });
  }
  // else {
  //   asyncRoutes[0].children = [asyncRoutes[0].children[0]];
  // }
  //   let menuList2=[{name:'开放平台',icon:'trajectory',children:[{link:'',name:"接口文档管理"},{link:'',name:"参数配置管理"},{link:'',name:"合作伙伴管理"}]},
  //   {name:'大数据中心',icon:'echarts',children:[{link:'',name:"模型管理"},{link:'',name:"标签管理"},{link:'',name:"可视化管理"}]},
  //   {name:'平台运营',icon:'label',children:[{link:'',name:"推广海报"},{link:'',name:"保险知识"},{link:'',name:"行业资讯"}]},
  //   {name:'用户管理',icon:'label',children:[{link:'',name:"用户列表管理"},{link:'',name:"注册用户管理"},{link:'',name:"用户标签管理"},{link:'',name:"代理人管理"},{link:'',name:"代理人关系架构"},{link:'',name:"行业排行"},{link:'',name:"代理人备案"}]},
  //   {name:'消息中心',icon:'label',children:[{link:'',name:"短信通知"},{link:'',name:"邮件通知"},{link:'',name:"系统站内信"},{link:'',name:"应用提醒"},{link:'',name:"消息模板"}]},
  //   {name:'精准营销',icon:'bell',children:[{link:'',name:"媒体管理"},{link:'',name:"广告位管理"},{link:'',name:"投放素材管理"},{link:'',name:"人群标签管理"},{link:'',name:"投放活动管理"},{link:'',name:"投放数据报表"}]},
  //   {name:'业务推广',icon:'bell',children:[{link:'',name:"计划书模板"},{link:'',name:"推广奖项配置"},{link:'',name:"产品奖项比例"},{link:'',name:"各级别销售分成"},{link:'',name:"二维码多级管理"},{link:'',name:"智能海报模板"}]},
  //   {name:'审核中心',icon:'label',children:[{link:'',name:"审核流管理"}]},
  //   {name:'订单管理',icon:'component',children:[{link:'',name:"订单管理"}]},
  //   {name:'保单管理',icon:'component',children:[{link:'',name:"保单列表"},{link:'',name:"犹豫期保单"},{link:'',name:"续保保单"}]},
  //   {name:'理赔管理',icon:'label',children:[{link:'',name:"索赔清单"},{link:'',name:"理赔产品"},{link:'',name:"理赔单参数"},{link:'',name:"理赔记录"},{link:'',name:"理赔申请审核"},{link:'',name:"理赔类型"},{link:'',name:"报案记录"}]},
  //   {name:'财务管理',icon:'label',children:[{link:'',name:"保费流水"},{link:'',name:"推广费统计"},{link:'',name:"绩效发放"},{link:'',name:"对账单"},{link:'',name:"费率管理"}]},
  //   {name:'可回溯',icon:'component',children:[{link:'',name:"可回溯管理"},{link:'',name:"视频图片"},{link:'',name:"加密保存"}]},
  //   {name:'内容管理',icon:'component',children:[{link:'',name:"隐私协议"},{link:'',name:"注册协议"},{link:'',name:"常见问题"}]},
  // ]
  // console.log(menuList,9999)
  // menuList2.map((item)=>{
  //   let route={
  //     name:item.children[0].link.split("/")[1],
  //     path: "/"+item.children[0].link.split("/")[1],
  //     component:mainLayout,
  //     meta:{
  //       title:item.name,
  //       icon:item.icon
  //     }
  //   }
  //   if(item.children){
  //     route.children=[]
  //     route.redirect=item.children[0].link.split("/index")[0],
  //     item.children.map((item2=>{
  //       let obj={
  //           name:  item2.link.split("/")[2],
  //           path: item2.link.split("/index")[0],
  //           component: () => Promise.resolve(require(`@/views${item2.link}`)),
  //           meta: { title: item2.name }
  //         }
  //         route.children.push(obj)
  //     }))
  //   }
  //   、
  // })
  menuList.map((item, index) => {
    let route = {};
    if (item.position == 1) {
      route = {
        name: item.children[0].link.split('/')[1],
        path: '/' + item.children[0].link.split('/')[1] + index,
        component: mainLayout,
        meta: {
          title: item.name,
          icon: item.icon,
          remark: item.remark
        }
      };
    } else if (item.position == 2) {
      route = {
        name: item.link.split('/')[1],
        path: '/' + item.link.split('/')[1],
        component: () => Promise.resolve(require(`@/views${item.link}`)),
        meta: {
          title: item.name,
          icon: item.icon,
          remark: item.remark
        }
      };
    }
    if (item.children) {
      route.children = [];
      route.redirect = item.children[0].link.split('/index')[0], item.children.map((item2, index2) => {
        let isPolicy = item2.link.split('/')[1] == 'policy' && (item2.link.split('/')[2] == 'customerManage' || item2.link.split('/')[2] == 'homeManage');
        let obj = {
          name: isPolicy ? item2.link.split('/')[2] + index2 : item2.link.split('/')[2],
          path: isPolicy ? item2.link : item2.link.split('/index')[0],
          component: () => Promise.resolve(require(`@/views${item2.link}`)),
          meta: {
            title: item2.name,
            remark: item2.remark
          }
        };
        route.children.push(obj);
      });
    }
    asyncRoutes[0].children.push(route);
  });
  console.log(asyncRoutes[0].children, 2222);
  // createRouter()
}
const createRouter = function () {
  return new VueRouter({
    routes: baseRoute,
    scrollBehavior: () => ({
      y: 0
    })
  });
};
const router = createRouter();
export function resetRouter() {
  router.matcher = createRouter().matcher;
}

//重定向时报错，用这个不让他报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
export default router;